import { Component, HostListener, OnInit, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Signaalkaarten} from '../../../signaalkaart/signaalkaarten';
import {SignaalkaartService} from '../../../signaalkaart/signaalkaart.service';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {Location} from '@angular/common';
import {map, mergeMap} from 'rxjs/operators';
import {Signaalkaart} from '../../../signaalkaart/signaalkaart';

@Component({
    templateUrl: './signaalkaarten.page.html',
    styleUrls: ['./signaalkaarten.page.scss'],
    standalone: false
})
export class SignaalkaartenPage implements OnInit {
  private clientService = inject(ClientService);
  private signaalkaartService = inject(SignaalkaartService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);

  client$: Observable<Client>;
  dienstId$: Observable<string>;
  signaalkaarten$: Observable<Signaalkaarten>;

  @HostListener('window:focus') onFocus() {
    window.location.reload();
  }
  ngOnInit(): void {
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('clientId')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
    this.dienstId$ = this.route.queryParamMap
      .pipe(
        map(queryParamMap => queryParamMap.get('dienstId'))
      );
    this.signaalkaarten$ = this.signaalkaartService.getLaatsteVersieSignaalkaarten$();
  }

  onSignaalkaartClicked(signaalkaart: Signaalkaart, client: Client, dienstId: string): void {
    this.router.navigate([`/signaalkaart/${signaalkaart.getId()}/cliënt/${client.getId()}`], { queryParams: { dienstId }});
  }

  navigateBack(): void {
    this.location.back();
  }
}
